import { z } from 'zod';
/** Validates the (role_handle, capability, org_id) key shape used by
 *  `recordCapabilityUsage` / `getLastCapabilityUse`. Not a full-row schema
 *  (this table has no client-facing create/update route — it's written
 *  exclusively by the auth-path recorder) — just a boundary check for the
 *  key fields, in case a future admin/debug endpoint wants to query it. */
export const CapabilityUsageKeySchema = z.object({
    roleHandle: z.string().min(1).max(64),
    capability: z.string().min(1).max(128),
    orgId: z.string().max(26).nullable().optional(),
});
//# sourceMappingURL=capability-usage.js.map